import "bootstrap/dist/css/bootstrap-reboot.min.css";
import "/src/styles/bootstrap-components.css";
import "bootstrap/dist/css/bootstrap-utilities.min.css";
import "bootstrap/dist/js/bootstrap.min";
import "@popperjs/core/dist/umd/popper.min";
import "/src/styles/global.css";
import "aos/dist/aos.css";
import "./src/helpers/iconify";

// Take over the route scroll: back/forward restores the saved position,
// every other navigation starts at the top. Anchors stay with Gatsby.
// behavior "instant" overrides the global CSS scroll-behavior: smooth for
// this one call, so the scroll is not cut off when the new page renders.
// Smooth scrolling elsewhere on the site is unchanged.
export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  if (location.hash) return true;
  const [, savedY] = getSavedScrollPosition(location) || [];
  window.scrollTo({ top: savedY || 0, left: 0, behavior: "instant" });
  return false;
};
